import { useTranslation } from 'react-i18next';
import { SpaceBetweenWrapper } from '../layouts/CommonLayoutStyles';
import Button from './CoreButton';

export interface IPaginationButtonRowProps {
    onNext: () => void;
    onPrevious: () => void;
    disableNext?: boolean;
    disablePrevious?: boolean;
    nextButtonText?: string;
    previousButtonText?: string;
}

export default function PaginationButtonRow({
    onNext,
    onPrevious,
    disableNext,
    disablePrevious,
    nextButtonText,
    previousButtonText,
}: IPaginationButtonRowProps) {
    const { t } = useTranslation();

    return (
        <SpaceBetweenWrapper>
            <Button
                $color="secondary"
                $size="small"
                startIcon="previous"
                onClick={onPrevious}
                disabled={disablePrevious}>
                {previousButtonText ?? t('common:previous')}
            </Button>
            <Button $color="secondary" $size="small" onClick={onNext} endIcon="forward" disabled={disableNext}>
                {nextButtonText ?? t('common:next')}
            </Button>
        </SpaceBetweenWrapper>
    );
}
